export function union<T = any> (...sets: Array<Set<any>>): Set<T> {
  return new Set(([] as Array<any>).concat(...sets.map(set => [...set])));
}

export function difference<T = any> (setA, setB): Set<T> {
  return new Set([...setA].filter(item => !setB.has(item)));
}
